import { tabStore } from '@/features/tabs/tabs.store';
import { navigate } from '@/utils/navigation-service';

/**
 * Open a new chat with `prompt` prefilled in the composer (never auto-sent). The `/chats` route
 * seeds the new-chat draft from `auto_prompt` on mount, so this is race-free. Opens in a new tab
 * when the tab bar is up, so whatever the reader was looking at stays open behind it.
 */
export const startChatWithPrompt = (prompt: string): void => {
  const search = { auto_prompt: prompt };
  if (tabStore.showTabBar) tabStore.createTab({ path: '/chats', search });
  void navigate({ to: '/chats', search });
};
